<template>
  <div class="error-box">
    <div class="icon">⚠️</div>

    <div class="content">
      <h3 class="title">
        {{ title ?? "Something went wrong" }}
      </h3>

      <p class="message">
        {{ message ?? "The component could not be loaded." }}
      </p>

      <details v-if="details" class="details">
        <summary>Details</summary>
        <pre>{{ details }}</pre>
      </details>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
  message?: string;
  details?: string;
}>();
</script>

<style scoped>
.error-box {
  display: flex;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border: 1px solid #f5c2c7;
  background: #f8d7da;
  color: #842029;
  border-radius: 0.5rem;
  align-items: flex-start;
}

.icon {
  font-size: 1.5rem;
  line-height: 1;
}

.title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.message {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
}

.details {
  margin-top: 0.5rem;
}

.details summary {
  cursor: pointer;
  font-size: 0.75rem;
  opacity: 0.8;
}

.details pre {
  margin-top: 0.25rem;
  padding: 0.5rem;
  background: #fff;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  overflow: auto;
}
</style>
